import { Method } from "axios";
import { ChatType, QuestionStatus, QuizLoginSteps, UserQuizStatus, VideoNumberTypeEnum } from "./enums";
import { FormEvent, MouseEventHandler } from "react";

export interface IParams {
    src?: string;
    type?: string;
    id?: string;
    fullscreen?: string;
    autoplay?: string;
    portrait?: string;
    t?: string;
    h?: string;
    isGeneral?: string;
    raw?: string;
    theme?: string;
    provider?: string;
    snapshot?: string;
    fullrate?: string;
    "e-url"?: string;
    "e-cover"?: string;
    cover?: string;
    uid?: string;
    user_id?: string;
    user_ids?: string;
    preview?: string;
    isAuth?: string;
    authentication?: string;
    site?: string;
    xToken?: string;
    width?: string;
    height?: string;
    chart?: string;
    onFinished?: Function;
    showModuleTitle?: string;
    scrollElementId?: string;
    onSnapshot?: (snapshot: string) => void;
    isMarkersChange?: boolean;
    quiz?: string;
    featureSet?: {
        downloadUrl?: string;
        feedback?: string;
        personalMarker?: string;
        profileFooter?: string;
        bookmark?: string;
        continuousPlayback?: string;
        videoUploadTime?: string;
        videoViewers?: string;
        recommendationList?: string;
        chat?: string;
        playlist?: string;
        enableTracker?: string;
        shareButton?: string;
    };
    uuid?: string;
    handleRedirectCards?: (id: string, type: string) => void;
    homeButtonClickFlag?: number | null;
}

export interface IDetails {
    stream_link: string;
    type: string;
    banner: string;
    id?: number;
    title?: string;
    description?: string;
    live_viewers?: number;
    viewers?: number;
    like?: number;
    start_time?: number;
    tag?: string;
    subtitles?: ISubtitle[];
    preview_start: null | number;
    preview_end: null | number;
    download_links: IDownloadLinks[];
    vtt?: string;
    vtt_mobile?: string;
    pg_state: number | null;
    user_id: number | null;
    online_viewer_threshold: number;
    content_id?: number;
    content_type: null | number;
    imdb_rate: null | number;
    release_year: null | number;
    duration: number;
}
export interface IDownloadLinks {
    quality: string;
    link: string;
}

export interface ISubtitle {
    id: number;
    lang: string;
    url: string;
}

export interface IMarker {
    banner: string;
    id: number;
    live_id: number;
    sticker: string;
    time: number;
    title: string;
    video_type: 1;
    vod_id: null | number;
    description: string;
    isPersonal: null | number;
}

export interface IEmoji {
    code: string;
    count: number;
    explode: boolean;
    spray: boolean;
}

export interface IVideoElementSizeInfo {
    bottom: number;
    top: number;
    left: number;
    right: number;
    width: number;
    height: number;
}

export interface IEnvironment {
    reduxDevTool: boolean;
}

export interface ITokens {
    access?: string;
    refresh?: string;
    id?: number;
    captcha_required?: any;
    token_id?: number;
}

export interface IApiCaller {
    url: string;
    method?: Method;
    data?: any;
    headers?: any;
    retryCount?: number;
    maxRetryCount?: number;
    delayDuration?: number;
    errorMessage?: string;
    retryPolicy?: IRetryPolicy[];
    errorCallback?: (status: number, message: string) => void;
    timeoutCount?: number;
}

export interface IRetryPolicy {
    codeAbove: number | null;
    codeBelow: number | null;
    excludeCodes: number[];
    includeCodes: number[];
    delay: number;
    count: number;
}

export interface IDetailsConfig {
    url: string;
    maxRetryCount: number;
    headers: any;
    retryPolicy: IRetryPolicy[];
    errorCallback?: (status: number, message: string) => void;
}

export interface IPlayList {
    title: string;
    id: number;
    count: number;
}

export interface IReplyToAuthor {
    author?: string;
    id?: number;
}

export interface IComments {
    id: number;
    replies_count: number;
    created_at: number;
    like: number;
    dislike: number;
    text: string;
    author: string;
    hidden: boolean;
    reply_to: number;
    content: number;
}

export interface ICommentsSlice {
    comments?: IComments[];
    commentsCount: number;
    commentsCountPagination: number;
    selectedEmoji: string;
    replyToAuthor: IReplyToAuthor;
    realTimeReply: undefined | IComments;
    commentDefaultMessages: ICommentDefaultMessages[];
    canAddComment: boolean;
    canShowSubmittedComment: boolean;
    usersCommentsProfiles: any[];
}

export interface IUsersCommentsProfiles {
    id: string;
    message: string;
    profile: {} | IProfile;
}

export interface IProfile {
    avatar_id: null | number;
    avatar_url: null | string;
    gender: null | string;
    name: null | string;
    username: null | string;
}

export interface IUserSlice {
    userId: string;
    authToken: string;
    refreshToken: string;
    avatar_url: string;
    name: string;
    phone_number: string;
    isLogin: boolean;
    settings: IUserSettings;
    videoSettings: IVideoSettings;
    bookmarks: IBookmark[];
    bookmarkId?: number;
    selectedPersonalMarker: IMarker | undefined;
    preFactor?: IPreFactor;
    factor?: IFactor | null;
    showContinuousePlayback: boolean;
}

export interface IPreFactor {
    id: number;
    price: number;
    max_usage: number;
    active_duration: number;
}
export interface IBookmark {
    object_link: string;
    cover_url: string;
    title: string;
    created_at: number;
    id: number;
}

export interface IUserSettings {
    quality: number;
    volume: number;
    brightness: number;
    speed: number;
    poll_emoji: boolean;
    subtitle_text_color: string;
    subtitle_background_color: string;
}

export interface IVideoSettings {
    is_like: boolean | null;
    time: number;
}

export interface ITagsSlice {
    selectedTags: string[];
    viewersTagsList: string[];
    inputTagSearch?: string;
    inputFilterTagSearch: string;
    isMovieFilter: boolean;
    isSeriesFilter: boolean;
}

export interface IWebListConfig {
    IWebListConfig: { key: string; value: string };
    value: string;
}

export interface IChatMessage {
    created_at: number;
    text: string;
    author: string;
    room_id: string;
    id: string;
    name?: string;
    avatar_url?: string;
    isConfirmed?: boolean;
}

export interface IChatSlice {
    messages?: IChatMessage[];
    usersInfoInChat: any;
    chatEnabled?: boolean;
    showChat: boolean;
    socket: any;
    roomId: any;
    chatType: ChatType;
    messageCount: number;
    defaultMessages: IChatDefaultMessages[];
    pinMessage: string | null;
}

export interface IChatDefaultMessages {
    id: number;
    message: string;
}

export interface ICommentDefaultMessages {
    id: number;
    score: number;
    text: string;
    user_id: number;
}

export interface IControllerSlice {
    play: boolean;
    isAutoPlay: boolean;
    duration: number;
    currentTime: number;
    mouseMoveTime: number;
    qualityLevels: number[];
    qualityBitrates: string[];
    manualQuality?: number;
    autoQuality?: number;
    activeElements: boolean;
    isLive: boolean;
    isLoading: boolean;
    isFullScreen: boolean;
    bufferedTimeWidth: number;
    firstPlay: boolean;
    hlsLiveSyncPosition: number;
    activePointerProgressBar: boolean;
    delayTurnOffControlbar: boolean;
    canPlayVideo: boolean;
    lock: boolean;
    isEnded: boolean;
    tooltipTime: number;
    showMiniPlayer?: boolean;
    isClickInnerCard: boolean;
    loadedFragmentsCount: number[];
}

export interface IPopoversSlice {
    markersListPopover: boolean;
    settingPopover: boolean;
    sharePopover: boolean;
    feedbackPopover: boolean;
    multiLivesPopover: boolean;
    pollPopover: boolean;
    fullRatePopover?: boolean;
    autoPlayPopover?: boolean;
    recommendListPopover: boolean;
    tagsPopover: boolean;
    speedPopover: boolean;
    playListPopover: boolean;
    playListCardPopover: boolean;
    commentPopover: boolean;
    personalMarkersPopover: boolean;
    bookmarksPopover: boolean;
    chatPopover: boolean;
    chatRulesPopover: boolean;
    chatEmojisPopover: boolean;
    trailerPopover: boolean;
    loginPopover: boolean;
}

export interface ISubtitleColor {
    bgName?: string;
    bgColor?: string;
    textName?: string;
    textColor?: string;
}

export interface IVideoDataSlice {
    details: IDetails;
    params: IParams;
    streamLinkParams: string;
    markers: IMarker[];
    liveId?: number;
    vodId?: number;
    onlineViewers?: number;
    question?: any;
    options?: any;
    selectedOptionId: number | null;
    emojis?: any;
    alternative_Lives: number[];
    config?: any;
    isLiveError: boolean;
    emojiList1: string[];
    emojiList2: string[];
    gif: string | null;
    errorType?: string;
    multiLives: any[];
    multiAudio?: any;
    selectedAudioId?: number;
    subtitles: any[];
    selectedSubtitle?: any;
    subtitleText?: string;
    isComplexPortrait?: boolean;
    isComplexDesktop: boolean;
    videoElementSizeInfo: IVideoElementSizeInfo;
    recommendationList: any;
    token: string;
    isFetchDetails: boolean;
    isValidAddress: boolean;
    playList?: IPlayList[];
    videoTimelines: number[];
    webListConfig: IWebListConfig[];
    chartPoints: number[];
    isReady: boolean;
    showScreen: boolean;
    trailer: any[];
    hlsLiveSyncPosition: number;
}

export interface IAxiosConfig {
    url: string;
    method: Method;
    headers: {
        "Content-Type": string;
        "ACCEPT-LANGUAGE": string;
        Authorization?: string;
    };
    data?: any;
    params?: any;
    timeout?: number;
}

export interface IStatusMessageError {
    status: number;
    message: string;
}

export type IStringKeyValue = { [key: string]: string };

// *** Quiz Player ***
export interface QuizType {
    id: number;
    user_id: number;
    name: string;
    response_interval: number;
    number_of_questions: number;
    is_active: boolean;
    live: number | null;
    questions: IQuizQuestions[];
    encrypted_quiz: string;
    remaining_time: number;
}

export interface IQuizQuestions {
    id: number;
    text: string;
    status: QuestionStatus;
    order: number;
    choices: IQuizChoice[];
    updated_at: number;
}

export interface IQuizChoice {
    id: number;
    text: string;
    is_correct: boolean;
    participants: number;
    question: number;
}

export interface IQuizSlice {
    quiz: QuizType[] | undefined | any;
    userStatus: UserStatus;
    step: QuizStep;
    correctAnswerId?: number;
    participants: number[];
    counter?: number;
    points: IQuizPoints;
    correctAnswersCount: number;
    participationAnswersCount: number;
    userAnswerId: number;
    userQuestionId: number;
    userQuestions: IUserQuestions[];
    chances: number;
    maxChances: number;
}

export interface IQuizPoints {
    userCorrectAnswers: number;
    userAnswers: number;
    userFirstAnswer: number;
    userLastAnswer: number;
}

export interface IQuizUserRecords {
    chance: string;
    question: IUserQuestions[];
}

export interface IUserQuestions {
    id: number;
    choice: {
        id: number;
    };
}

export type UserStatus = UserQuizStatus.participant | UserQuizStatus.viewer | UserQuizStatus.loser;
export type QuizStep = 0 | 1 | 2 | 3 | 4;

// *** Props Interfaces ***
export interface IVideoTagProps {
    isMultiLive?: boolean;
}

export interface IToggleProps {
    enabled: boolean;
    setEnabled: any;
}

export interface IPlayerCoreProps {
    isMultiLive?: boolean;
}

export interface ITagsProps {
    tags: string;
    usePlace?: string;
    tagId: string;
}

export interface ISelectedTagsVideoListProps {
    setListScrolled: (listScrolled: any[]) => void;
    listScrolled: any[];
    videoCount: number;
}

export interface ISubtitleIconsProps {
    onClick: () => void;
    onDoubleClick: (event: any) => void;
    onMouseOver: () => void;
    onMouseLeave: () => void;
}

export interface ICircleSpinnerProps {
    className?: string;
}

export interface ISpeedIconProps {
    onClick: () => void;
    onMouseOver: () => void;
    onMouseLeave: () => void;
}

export interface ISoundVolumeIconProps {
    onClick: () => void;
    onDoubleClick: (event: any) => void;
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
}

export interface IShareDialogProps {
    status: boolean;
    onClose: any;
    currentTime?: number;
    markerId?: number;
}

export interface IPopoverProps {
    children: JSX.Element;
    type: "modal" | "popover";
    onClose: any;
    classNames?: string;
    parentClassNames?: string;
    styles?: any;
    status?: boolean;
    isBlurBackground?: boolean;
    isFullHeight?: boolean;
    isFullScreen?: boolean;
    isHeader?: boolean;
    headerTitle?: string;
    customHeader?: any;
    headerClassName?: string;
    isHasCatchUpLineOnTop?: boolean;
    animation?: string;
    scrollbar?: boolean;
    isFocusOnInput?: boolean;
    showCloseIcon?: boolean;
    pinContent?: any;
}

export interface IQuizPopoverProps {
    children: JSX.Element;
    type: "modal" | "popover";
    onClose: any;
    classNames?: string;
    parentClassNames?: string;
    headerClassNames?: string;
    styles?: any;
    status?: boolean;
    isBlurBackground?: boolean;
    isFullHeight?: boolean;
    isHeader?: boolean;
    headerTitle?: string;
    customHeader?: any;
    isHasCatchUpLineOnTop?: boolean;
    animation?: string;
    scrollbar?: boolean;
    isFocusOnInput?: boolean;
}

export interface IPortraitPollOptionsProps {
    option: any;
    lastOptionId: number;
    sumVotes: number;
    onClick: () => void;
}

export interface IPollOptionProps {
    option: any;
    lastOptionId: number;
    sumVotes: number;
    onClick: () => void;
}

export interface IPlayPauseIconProps {
    onClick: (event: any) => void;
    onDoubleClick: (event: any) => void;
}

export interface IPlayNextVideoIconProps {
    onClick: () => void;
    onMouseOver: () => void;
    onMouseLeave: () => void;
}

export interface IPlayListCardProps {
    playListCardInfo: any;
}

export interface IPlayerCardProps {
    src: string;
    type: string;
    width: number | "unset";
    height: number;
    title?: string;
    titleClassName?: string;
    tags?: string;
    date?: number;
    dateClassName?: string;
    viewers?: number;
    viewersClassName?: string;
    isVideo?: boolean;
    isComplexDesktop?: boolean;
    isMultiLive?: boolean;
    duration?: number | string;
    onClick: any;
    id: number;
    userId?: number;
    isTagCard?: boolean;
    commentsCount?: number;
    star?: number;
    imdb_rate?: null | number;
    status_text?: null | string;
    content_type?: null | number;
}
export interface INotActiveProps {
    title: string;
    description: string;
    type: string;
}

export interface IMultiLiveIconProps {
    onClick?: () => void;
    onMouseOver: () => void;
    onMouseLeave: () => void;
}

export interface IMultiLiveIcon1Props {
    className?: string;
    width?: number;
    height?: number;
    strokeColor?: string;
    onClick?: () => void;
}

export interface IMultiLiveDialogProps {
    status: boolean;
    onClose: any;
}

export interface IMarkerListIconProps {
    className?: string;
    onClick?: () => void;
    onDoubleClick?: (event: any) => void;
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
}

export interface IUnlockIconProps {
    onClick: () => void;
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
    className?: string;
    style?: any;
}

export interface IUnlockProps {
    inControllbar?: boolean;
}

export interface ILockIconProps {
    onClick: () => void;
    className?: string;
    style?: any;
}

export interface ILockProps {
    className?: string;
}

export interface ILiveIconProps {
    isLive: Boolean;
}

export interface ILiveStatusProps {
    className?: string;
}

export interface ILikeIconProps {
    className?: string;
    onClick?: () => void;
    onDoubleClick?: (event: any) => void;
    isLike: boolean;
}

export interface IDislikeIconProps {
    className?: string;
    onClick?: () => void;
    onDoubleClick?: (event: any) => void;
    isDislike: boolean;
}

export interface IAnimateEmojiProps {
    emojiCode: string;
    direction: "LEFT" | "RIGHT";
}

export interface IUniEmojiProps {
    EmojiList: { code: string; count: number }[];
    direction: "RIGHT" | "LEFT";
    normalizeCoefficient: number;
}

export interface ISprayEmojiProps {
    codes: string[];
    direction: "RIGHT" | "LEFT";
}

export interface IExplodeEmojiProps {
    codes: string[];
    direction: "RIGHT" | "LEFT";
}

export interface IFullScreenIconProps {
    onClick: () => void;
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
}

export interface IEmojiPickerProps {
    onClickOutside: any;
    setSelectedEmoji: (value: string) => void;
    parentClassName?: string;
    emojiClassName?: string[];
    enableUnified: boolean;
}

export interface IEmojiType {
    id?: string;
    keywords?: string[];
    name?: string;
    native?: string;
    shortcodes?: string;
    unified: string;
}

export interface IEmojiProps {
    name: string | undefined;
    className?: string;
    dataMarker?: string;
}

export interface ICopyTextProps {
    link?: string;
    markerId?: number;
    videoTime?: number;
    isJump: boolean;
}

export interface IConfirmationModalProps {
    status: boolean;
    onClose: () => void;
    onSubmit: () => void;
    modalType: "DELETE" | "ACTION";
    text: any;
    cancelButtonText: string;
    submitButtonText: string;
    rotateButtons?: boolean;
    children?: any;
}

export interface ITouchScreenCommentObserverProps {
    setScrollEnd: (value: boolean) => void;
}

export interface ITouchScreenplaylistObserverProps {
    setScrollEnd: (value: boolean) => void;
}

export interface ISingleReplyProps {
    replies: IComments[];
    setReplies: (values: IComments[]) => void;
    reply: IComments;
    usersRepliesProfiles: any[];
    commentsLocalStorageIds: number[];
    setRepliesCount: (repliesCount: number) => void;
}

export interface ISingleCommentProps {
    comment: IComments;
    user: any;
    commentsLocalStorageIds: number[];
}

export interface ILikeCommentProps {
    commentId: number;
    likesCount: number;
    isIdInLocalStorage: boolean;
}

export interface ICommentsPopoverProps {
    status: boolean;
    onClose: () => void;
    setScrollEnd: (value: boolean) => void;
}

export interface ICommentPopoverProps {
    status: boolean;
    onClose: () => void;
    setScrollEnd: (value: boolean) => void;
}

export interface ICommentContentPopoverProps {
    setScrollEnd: (value: boolean) => void;
}

export interface IAddCommentProps {
    type: string;
    setShowReplyBox?: (value: boolean) => void;
}

export interface ICheckboxProps {
    label: string;
    onChange: (value: boolean) => void;
    defaultValue?: boolean;
    labelClassName?: string;
}

export interface IChatCardProps {
    message: IChatMessage;
}

export interface IBackwardForwardProps {
    type: string;
    isRightDoubleTouched?: boolean;
    isLeftDoubleTouched?: boolean;
    setIsRightDoubleTouched?: (value: boolean) => void;
    setIsLeftDoubleTouched?: (value: boolean) => void;
}

export interface IControllbarTooltipProps {
    title: string;
    className?: string;
}

export interface IVideoListHeaderProps {
    className?: string;
}

export interface IUnMuteProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface ITagsEmptyStateProps {
    className?: string;
}

export interface IStarIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IStarSlashIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IShareIconProps {
    className?: string;
    onClick?: (event: any) => void;
    onDoubleClick?: (event: any) => void;
}

export interface IShare1IconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IProfileIconProps {
    className?: string;
}

export interface IPlusEmojiIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IPlaylistIconProps {
    className: string;
}

export interface IPersonalMarkerIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IOnlineViewerIconProps {
    className?: string;
    onClick?: () => void;
}

export interface IMuteProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IMessageIconProps {
    className?: string;
    onClick?: () => void;
}

export interface IFeedbackIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IDownloadIconProps {
    className?: string;
}

export interface ICopyProps {
    className?: string;
    onClick?: () => void;
}

export interface ICloseIconProps {
    className?: string;
    onClick?: () => void;
}

export interface IClockIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IChevronRightProps {
    className?: string;
    onClick?: () => void;
}

export interface IChevronLeftProps {
    className?: string;
    onClick?: () => void;
}

export interface IChatIconProps {
    className?: string;
}

export interface ICameraIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IBookmarkIconProps {
    className?: string;
    isBookmark?: boolean;
    onClick?: (event: any) => void;
    type?: "single" | "double";
}

export interface IArrowUpIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IArrowTopTrailerProps {
    className?: string;
    onClick?: () => void;
}

export interface IArrowRightTrailerProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IArrowLeftTrailerProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IArrowLeftProps {
    className?: string;
    onClick?: () => void;
}

export interface IArrowDownIconProps {
    className?: string;
    onClick?: (event: any) => void;
}

export interface IArrowBottomTrailerProps {
    className?: string;
    onClick?: () => void;
}

export interface ICircleProgresesBarProps {
    counter: number;
    maxValue: number;
}

export interface IHourglassSpinnerProps {
    title: string;
    titleClassNames?: string;
}

export interface IOnlineViewerIconProps {
    className?: string;
    onClick?: () => void;
}
export interface IPlayerModule {
    type: string;
}
export interface ISinglePlayListProps {
    playList: any;
}

export interface IHeartIconProps {
    className: string;
}

export interface IPhoneInputProps {
    value?: string;
    onChange?: (value: string) => void;
    label?: string;
    placeholder?: string;
    icon?: any;
    disable?: boolean;
    error?: string;
    className?: string;
    parentClassName?: string;
    autoFocus?: boolean;
}

export interface ICaptchaType {
    id?: string;
    image?: string;
    provider?: string;
    value?: string;
}

export interface ICaptchaProps {
    error?: string;
    captcha: ICaptchaType | undefined;
    handleClickButton?: any;
    getNewCaptcha?: any;
    loading?: boolean;
    setCaptchaValue: (captcha: ICaptchaType) => void;
}

export interface ILoginFormDataInterface {
    phone: string;
    phoneFormat: string;
    password?: string;
    code?: string;
}

export interface IArrowLeft1PropsInterface {
    className?: string;
    onClick?: any;
}

export interface ICodeInputPropsInterface {
    onChange: (value: string) => void;
    activeColor?: string;
}
export interface ICaptchaType {
    id?: string;
    image?: string;
    provider?: string;
    value?: string;
}

export interface IFactor {
    active_duration: number;
    max_usage: number;
    start_time: string;
    current_usage: number;
    channel: number;
}

export interface IPrintIconProps {
    className?: string;
    onClick?: any;
}

export interface IRotateIconProps {
    className?: string;
}

export interface IHomeIconProps {
    className?: string;
}

export interface ISmsStarProps {
    className?: string;
}
export interface ICountDown {
    resendCodeTime: number;
    setResendCodeTime: (value: number) => void;
    handleGenerateCode: () => void;
    isLoading: boolean;
}

export interface IStarsProps {
    userRating: number;
    setUserRating: (rating: number) => void;
    setButtonActive: (buttonActive: "positive" | "negative") => void;
    starsLabels: string[];
}

export interface IViewedVideo {
    video_id: number;
    video_type: VideoNumberTypeEnum.Vod | VideoNumberTypeEnum.Archive | VideoNumberTypeEnum.Clip | VideoNumberTypeEnum.FutureLive;
    time: number;
    is_like: boolean | null;
}
export interface IInfoIcon {
    className?: string;
}

export interface IParamsErrorPopoverProps {
    requiredsItems: string[];
    notRequiredsItems: string[];
}

export interface IPlaylistVideoCards {
    onClick: (playlistId: number) => void;
    playList: any;
    videoPlaylist: any;
    selectedPlaylist: number;
    scrollEnd: boolean;
}
export interface IPinIcon {
    className?: string;
}

export interface IJudgeIcon {
    className?: string;
}
export interface IQuizFormData {
    mobileNumber: string;
    requestId: string;
}

export interface IButton {
    type?: "submit" | "button";
    text: string;
    className?: string;
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
    disabled?: boolean;
}

export interface IQuizGenerateCode {
    event?: FormEvent<HTMLFormElement>;
    quizFormData: IQuizFormData;
    setQuizFormData: (formData: IQuizFormData) => void;
    setLoading: (isLoading: boolean) => void;
    setMobileNumberError?: (value: boolean) => void;
    setResendCodeTime?: (value: number) => void;
    setLoginStep: (loginStep: QuizLoginSteps.mobileNumber | QuizLoginSteps.otp) => void;
}

export interface IQuizLoginOtp {
    event?: FormEvent<HTMLFormElement>;
    otpCode: string;
    quizFormData: IQuizFormData;
    setLoading: (isLoading: boolean) => void;
}

export interface IQuizLoginContext {
    loginStep: QuizLoginSteps.mobileNumber | QuizLoginSteps.otp;
    setLoginStep: (loginStep: QuizLoginSteps.mobileNumber | QuizLoginSteps.otp) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
    resendCodeTime: number;
    setResendCodeTime: (resendCodeTime: number) => void;
    quizFormData: IQuizFormData;
    setQuizFormData: (quizFormData: IQuizFormData) => void;
    handleGenerateCode: (values: IQuizGenerateCode) => void;
}

export interface ICommentSettingsProps {
    commentId: number;
    isReply?: boolean;
    replies?: IComments[];
    setReplies?: (replies: IComments[]) => void;
    setRepliesCount?: (repliesCount: number) => void;
}

export interface ICommentSettingsPopoverProps {
    setShowPopover: (showPopover: boolean) => void;
    isReply?: boolean;
    replies?: IComments[];
    setReplies?: (replies: IComments[]) => void;
    commentId: number;
    setRepliesCount?: (repliesCount: number) => void;
    touchPosition?: {
        x: number;
        y: number;
    };
}
